
import { Watch, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import EventBus from "front-component/EventBus";
import {Action, Getter} from "vuex-class";
import {RequestFilters} from "@/modules/request/RequestFilters";
import {SocleFilters} from "@/modules/SocleFilters";

@Component
export default class List extends Vue {
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string|null;
    @Action("resetSocleFilters") public resetSocleFilters!: (filters: SocleFilters | null) => void;
    @Action("resetRequestFilters") public resetRequestFilters!: (filters: RequestFilters | null) => void;
    protected orders: object = {};

    public mounted() {
        EventBus.$on("update-filter", this.updateFilter);
        EventBus.$on("update-order", this.updateOrder);
    }

    public beforeDestroy(): void {
        EventBus.$off("update-filter", this.updateFilter);
        EventBus.$off("update-order", this.updateOrder);
    }

    public updateOrder(order: object): void {
        // Only few actions as "assign" triggers the watch on the object
        this.orders = Object.assign({}, this.orders, order);
    }

    public updateFilter(_: any): void {
        // intentionally empty: overridden by child components
    }

    @Watch("currentOwnerUuid")
    private refreshFilters(): void {
        this.resetSocleFilters(null);
        this.resetRequestFilters(null);
    }
}
